import { render, staticRenderFns } from "./DiagramHandItem.vue?vue&type=template&id=986cfb76&"
import script from "./DiagramHandItem.vue?vue&type=script&lang=js&"
export * from "./DiagramHandItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports